module.exports = __webpack_public_path__ + "img/goods_default.3cd1d1ef.png";